export interface DevConfig {
  /** Toggle the reference floor/ceiling grid helpers */
  showReferenceGrid: boolean;
  /** Toggle the global map grid + axes helpers */
  showGlobalMapReferenceGrid: boolean;
  /** Outline each collision volume or helper mesh with wireframes */
  showCollisionBounds: boolean;
  /** Toggle magenta markers for every sight point */
  showSightMarkers: boolean;
  /** Optional override for the orbit view center */
  orbitCenterOverride: {
    x: number;
    y: number;
    z: number;
  } | null;
  /** Whether to show a helper sphere at the orbit center */
  showOrbitCenterMarker: boolean;
  /** Toggle the teller assistant mesh */
  showTellerAssistant: boolean;
  /** Toggle the rear-view spark overlay */
  showRearView: boolean;
  /** Optional override for the assistant API host */
  assistantApiHost: string;
  /** Optional assistant API bearer token */
  assistantApiToken: string;
}

export const defaultDevConfig: DevConfig = {
  showReferenceGrid: false,
  showGlobalMapReferenceGrid: false,
  showCollisionBounds: false,
  showSightMarkers: false,
  orbitCenterOverride: null,
  showOrbitCenterMarker: false,
  showTellerAssistant: false,
  showRearView: false,
  assistantApiHost: 'https://pilgrim-ai-api.rodincraft.ru',
  assistantApiToken: 'pil-b564cQPKYzimu9mVDt',
};
